import React from "react";
import { useGetMoviesList } from "../hooks/useGetMoviesList";
import MovieList from "./MovieList";
import { useSelector } from "react-redux";

export const SecondaryContainer = () => {
  useGetMoviesList();
  const nowPlayingMovies = useSelector(
    (state) => state.movies.nowPlayingMovies
  );
  const popularMovies = useSelector((state) => state.movies.popularMovies);
  const topRatedMovies = useSelector((state) => state.movies.topRatedMovies);
  const upcomingMovies = useSelector((state) => state.movies.upcomingMovies);
  return (
    <div className="bg-black text-white">
      <div className="-mt-[8%]">
        {nowPlayingMovies?.length > 0 && (
          <MovieList title="Now Playing" movies={nowPlayingMovies} />
        )}
        {topRatedMovies?.length > 0 && (
          <MovieList title="Top Rated" movies={topRatedMovies} />
        )}
        {popularMovies?.length > 0 && (
          <MovieList title="Popular" movies={popularMovies} />
        )}
        {upcomingMovies?.length > 0 && (
          <MovieList title="Upcoming" movies={upcomingMovies} />
        )}
      </div>
    </div>
  );
};
